import { Button, Input } from '@mui/material';
import React from 'react'
import Select from 'react-select';
import { colourStyles } from './tablist';

export const ExamFilter = (props) => {

    return <>
    {props?.showFilter && (
    <div class="row" style={{ margin: "15px" }}>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">Subject</label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Select
              isMulti={true}
              name="filteredSubject"
              value={props?.filteredSubject}
              options={props?.subjectValue.map((el) => {
                return {
                  value: el.value,
                  label: el.label,
                };
              })}
              onChange={(item) => {
                props.setFilteredSubject(item);
                if (item.length === 0) {
                  props.setSearch(true);
                }
              }}
            ></Select>
          </div>
        </div>
        {true && (
          <div class="form-sub-div">
            <label class="form-label">Courses </label>
            <div
              class="form-elements"
              style={{ fontSize: "15px" }}
            >
              <Select
                class="form-details"
                placeholder="select the course"
                name="courseCode"
                value={props.courseValue}
                options={props.courses.map((el) => {
                  return {
                    value: el.courseId,
                    label: el.course,
                  };
                })}
                components={{
                  IndicatorSeparator: () => null,
                }}
                styles={props.colourStyles}
                isMulti={true}
                onChange={(e) => {
                  props.setCourseValue(e);
                }}
              />
            </div>
          </div>
        )}
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">Tags</label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Select
              class="form-details"
              placeholder="select the tag"
              name="courseCode"
              value={props.tagValue}
              options={props.tags.map((el) => {
                return {
                  value: el.tagId,
                  label: el.tagName,
                };
              })}
              components={{
                IndicatorSeparator: () => null,
              }}
              styles={colourStyles}
              isMulti={true}
              onChange={(e) => {
                props.setTagValue(e);
              }}
            />
          </div>
        </div>

        <div class="form-sub-div">
          <label class="form-label">Topics</label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Select
              class="form-details"
              placeholder="select the topic"
              name="courseCode"
              value={props?.topicValue}
              options={props?.topics.map((el) => {
                return {
                  value: el.topicId,
                  label: el.topic,
                };
              })}
              components={{
                IndicatorSeparator: () => null,
              }}
              styles={colourStyles}
              isMulti={true}
              onChange={(e) => {
                props.setTopicValue(e);
              }}
            />
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">Created by</label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Select
              isMulti={false}
              value={props.createdBy}
              options={props.users.map((el) => {
                return {
                  value: el.userID,
                  label: el.email,
                };
              })}
              onChange={(item) => {
                props.setCreatedBy(item);
              }}
            ></Select>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">Approved by</label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Select
              value={props.approvedBy}
              options={props.users.map((el) => {
                return {
                  value: el.userID,
                  label: el.email,
                };
              })}
              onChange={(item) => {
                props.setApprovedBy(item);
              }}
            ></Select>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">Complexity</label>
          <div class="form-elements">
            <select
              class="form-details"
              name="complexity"
              defaultValue={props.complexity}
              onChange={(e) => {
                props.setComplexity(e.target.value);
              }}
            >
              <option value="ALL">All</option>
              <option value="WASY">Easy</option>
              <option value="MEDIUM">Medium</option>
              <option value="HIGH">High</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">Issue Reported</label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Select
              isMulti={false}
              value={props.issueReported}
              options={[
                { value: true, label: "True" },
                { value: false, label: "False" },
              ]}
              onChange={(item) => {
                props.setIssueReported(item);
              }}
            ></Select>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">
            Include Questions From QB
          </label>
          <div class="form-elements">
            <select
              class="form-details"
              onChange={(e) => {
                props.setIncludeQuestionsFromQB(
                  e.target.value === "True"
                );
              }}
            >
              <option value="True">True</option>
              <option value="False">False</option>
            </select>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">
            {`num Of Times Used In Exam >=`}{" "}
          </label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Input
              type="number"
              value={props.numOfTimesUsedInExam}
              onChange={(item) => {
                props.setNumOfTimesUsedInExam(item.target.value);
              }}
            />
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">
            {`Created Date >`}{" "}
          </label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Input
              type="date"
              value={props.createdDate}
              onChange={(item) => {
                props.setCreatedDate(item.target.value);
              }}
            />
          </div>
        </div>
      </div>

      <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
        <div class="form-sub-div">
          <label class="form-label">
            {`Updated Date >`}{" "}
          </label>
          <div
            class="form-elements"
            style={{ fontSize: "15px" }}
          >
            <Input
              type="date"
              value={props.updatedDate}
              onChange={(item) => {
                props.setUpdatedDate(item.target.value);
              }}
            />
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "flex-end",
        }}
      >
        <Button
          variant="outlined"
          style={{
            margin: "10px",
          }}
          onClick={() => {
            props.setApprovedBy("");
            props.setCourseValue([]);
            props.setFilteredSubject([]);
            props.setTagValue([]);
            props.setTopicValue([]);
            props.setCreatedBy("");
            props.setComplexity("ALL");
            props.setNumOfTimesUsedInExam(0);
            props.setCreatedDate(null);
            props.setUpdatedDate(null);
            props.setIssueReported({
              value: false,
              label: "False",
            });
            props.setIncludeQuestionsFromQB(true);
          }}
        >
          Reset
        </Button>
        <Button
          style={{
            margin: "10px",
          }}
          variant="outlined"
          onClick={() => props.setSearch(true)}
          disabled={props.filteredSubject.length === 0}
        >
          Search
        </Button>
      </div>
    </div>)}
    </>
  }

